/* eslint-disable */
import Card from './Card';
const SELECTOR = '.event-listing';
const $ = jQuery;
class EventListing {
  constructor() {
    if ($(SELECTOR).length === 0) {
      return false;
    }

    const initOpen = false;
    let paginationClicked = false;
    let isFiltered = false;
    let isCalendarFiltered = false;
    let checkboxElem = null;

    function enableCardHover() {
      setTimeout(() => Card(), 250);
    }

    function customCalendarFunction() {
      const $dates = $('.facetwp-type-date_range-custom .facetwp-date:not(".ready, .flatpickr-alt")');

      if (0 === $dates.length) {
        return;
      }

      const monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
      ];

      const urlParams = new URLSearchParams(window.location.search);
      const eventParams = urlParams.get('_event_date_range');

      let calendarOpen = false;
      let today = new Date();
      const dd = String(today.getDate()).padStart(2, '0');
      const mm = String(today.getMonth() + 1); //January is 0!
      const yyyy = today.getFullYear();

      today = yyyy + '-' + mm + '-' + dd;

      const flatpickr_opts = {
        altInput: true,
        altFormat: 'F Y',
        altInputClass: 'flatpickr-alt',
        dateFormat: 'Z',
        static: true,
        disableMobile: true,
        locale: FWP_JSON.datepicker.locale,
        ignoredFocusElements: [document.body],
        locale: {
          weekdays: {
            shorthand: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
          },
        },
        onChange(selectedDates, dateStr, instance) {
          //instance.close();
          isCalendarFiltered = true;
          FWP.autoload();

          window.dataLayer.push({
            event: 'calendar',
            dateSelection: `${selectedDates[0].getFullYear()}-${selectedDates[0].getMonth() + 1}-${String(selectedDates[0].getDate()).padStart(2, '0')}`,
          });
        },
        onOpen() {
          calendarOpen = true;
          $dates.closest('.event-listing__calendar').find('.event-listing__calendar-close').removeClass('event-listing__visible');
          $dates.closest('.event-listing__calendar').find('.event-listing__calendar-open').addClass('event-listing__visible');
        },
        onClose() {
          calendarOpen = false;
          $dates.closest('.event-listing__calendar').find('.event-listing__calendar-close').addClass('event-listing__visible');
          $dates.closest('.event-listing__calendar').find('.event-listing__calendar-open').removeClass('event-listing__visible');
        },
        onReady(dateObj, dateStr, instance) {
          $dates.closest('.event-listing__calendar').find('.event-listing__calendar-close').addClass('event-listing__visible');
          $('.flatpickr-monthDropdown-months').attr('title', 'Select Month');

          // if (!initOpen) {
          //   initOpen = true;
          //   instance.open();
          // }
          const { now, altInput } = instance;
          const dateInit = new Date(now);
          const dateInitMonth = monthNames[dateInit.getMonth()];
          const dateInitYear = dateInit.getFullYear();
          const dateInitPHolder = dateInitMonth + ' ' + dateInitYear;

          if (!$(altInput).val()) {
            $(altInput).val(dateInitPHolder);
          }

          if (window.outerWidth > 1024) {
            calendarOpen = true;
            $('.event-listing__open-cal').attr('title', 'Close Calendar Filter');
            instance.open();
          }
        },
      };

      $dates.each(function() {
        const $this = $(this);
        const facet_name = $this.closest('.facetwp-facet').attr('data-name');

        const opts = FWP.hooks.applyFilters('facetwp/set_options/date_range', flatpickr_opts, {
          facet_name,
          element: $this,
        });

        let flatpckr = '';

        if (eventParams) {
          delete flatpickr_opts.defaultDate;
          flatpckr = new flatpickr(this, opts);
        } else {
          flatpickr_opts.defaultDate = [today],
          flatpckr = new flatpickr(this, opts);
        }

        $('.event-listing__open-cal').on('click', e => {
          if (calendarOpen) {
            $(e.currentTarget).removeClass('is-open');
            $(e.currentTarget).attr('title', 'Open Calendar Filter');
            flatpckr.close();
          } else {
            $(e.currentTarget).addClass('is-open');
            $(e.currentTarget).attr('title', 'Close Calendar Filter');
            flatpckr.open();
          }
        });

        $this.addClass('ready');
      });
    }

    function filterToggles() {
      const $filters = $('.event-listing .search-types-toggler');

      $filters.each(function() {
        const $this = $(this);

        $this.on('click', e => {
          const filterPanel = $(e.currentTarget);
          panelToggle(filterPanel);
          panelA11yToggle(filterPanel);
        });

        panelToggleOnLoad($this);
        panelA11yToggle($this);
      });
    }

    function panelToggle(elem) {
      const filterPanel = elem.closest('.event-listing__filter');

      if (! filterPanel.hasClass('is-open')) {
        filterPanel.addClass('is-open');
      } else {
        filterPanel.removeClass('is-open');
      }
    }

    function panelToggleOnLoad(elem) {
      const filterPanelFacet = elem.closest('.hub-filter__search-types');
      const filterPanel = elem.closest('.event-listing__filter');
      if (filterPanelFacet.hasClass('type--is-open')) {
        filterPanel.addClass('is-open');
        filterPanelFacet.closest('.event-listing__filter').addClass('is-open');
        panelA11yToggle(elem);
      } else {
        panelA11yToggle(elem);
      }
    }

    function panelA11yToggle(elem) {
      const filterPanel = elem.closest('.event-listing__filter');

      if (filterPanel.hasClass('is-open')) {
        elem.attr('aria-expanded', 'true');
      } else {
        elem.attr('aria-expanded', 'false');
      }
    }

    function mobileToggle() {
      const filterMobilePanel = $('.event-listing__mobile-panel');
      const filterMobilePanelBtn = $('.event-listing__mobile-panel .event-listing__mobile-btn');
      filterMobilePanelBtn.on('click', () => {
        if (filterMobilePanel.hasClass('mobile-is-open')) {
          filterMobilePanel.removeClass('mobile-is-open');
        } else {
          filterMobilePanel.addClass('mobile-is-open');
        }
      });
    }

    function eventListingA11y() {
      const firstCard = document.querySelector('.event-listing__month-group:first-child .hub-result__list-item:nth-child(2) .card__link-cover');
      const paginationNext = $('.facetwp-page.next');
      const paginationPrev = $('.facetwp-page.prev');
      const paginations = $('.facetwp-page:not(.next):not(.prev)');

      $('.facetwp-checkbox').on('click', e => {
        checkboxElem = $(e.target).attr('data-value');
        isFiltered = true;
        window.dataLayer.push({
          event: 'filter',
          eventType: 'filter select',
          filterFacet: $(e.target.parentNode).attr('data-gtm-value'),
        });
      });

      $('.facetwp-page').on('click', e => {
        const pageElem = $(e.target).hasClass('prev') || $(e.target).hasClass('next') ? $(e.target).hasClass('prev') ? 'prev' : 'next' : $(e.target).attr('data-page');

        window.dataLayer.push({
          event: 'pagination',
          clickTarget: pageElem,
        });
      });

      if (firstCard && paginationClicked) {
        firstCard.focus();
        paginationClicked = false;
      }

     setTimeout(() => {
       if (paginationNext.attr('data-page')) {
         paginationNext.attr('aria-label', 'Go to Page ' + paginationNext.attr('data-page'));
         paginationNext.removeAttr('aria-hidden');
         paginationNext.attr('tabindex', '0');
       } else {
         paginationNext.attr('aria-hidden', 'true');
         paginationNext.attr('tabindex', '-1');
       }

       if (paginationPrev.attr('data-page')) {
         paginationPrev.attr('aria-label', 'Go to Page ' + paginationPrev.attr('data-page'));
         paginationPrev.removeAttr('aria-hidden');
         paginationPrev.attr('tabindex', '0');
       } else {
         paginationPrev.attr('aria-hidden', 'true');
         paginationPrev.attr('tabindex', '-1');
       }

       paginations.each(function () {
         $(this).attr('aria-label', 'Page ' + $(this).attr('data-page'));
       });
     }, 50);
    }

    $(document).on('facetwp-loaded', function() {
      eventListingA11y();
      customCalendarFunction();

      if (checkboxElem) {
        setTimeout(() => {
          document.querySelector('.facetwp-checkbox[data-value="' + checkboxElem + '"]').focus();
          checkboxElem = null;
        }, 50);
      }

      if (isFiltered || isCalendarFiltered) {
        filterToggles();
        isFiltered = false;
        isCalendarFiltered = false;
      }

      enableCardHover();
      $('html, body').animate({
        scrollTop: $('#results').offset().top - 160,
      }, 800);

      //Focus on the current target

      if ($(document.currentTarget).attr('data-value')) {
        document.currentTarget.focus();
      }

      paginationClicked = false;
    });

    $(document).on('click', '.facetwp-page[data-page]', function() {
      paginationClicked = true;
    });

    eventListingA11y();
    mobileToggle();
    filterToggles();
    customCalendarFunction();
  }
}

export default EventListing;
